import { useForm } from 'libs/form'
import type { FieldValues } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { routes } from 'config/routes'
import { BackButton, Form, Header } from 'shared/components'
import { DEFAULT_COLOR } from 'features/rentals/rentals.config'
import { useRentalValidationSchema } from 'features/rentals/hooks/useRentalValidationSchema'
import { RentalFormSections } from 'features/rentals/organisms/RentalForm/RentalFormSections'
import { toRentalPayload } from 'features/rentals/utils/toRentalPayload'
import { useCreateRentalMutation } from './mutations/useCreateRentalMutation'

const RentalAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useRentalValidationSchema()

	const form = useForm<FieldValues>({
		mode: 'onChange',
		resolver: validationResolver,
		defaultValues: {
			color: DEFAULT_COLOR
		}
	})
	const { handleSubmit } = form

	const { createRental, createRentalLoading } = useCreateRentalMutation()

	return (
		<>
			<Header
				title={t('Add rental')}
				eyebrow={t('Booking engine')}
				actions={<BackButton to={routes.rentalIndex} text={t('Back to rentals')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Create rental')}
					onSubmit={handleSubmit((data) => createRental(toRentalPayload(data)))}
					isLoading={createRentalLoading}>
					<RentalFormSections form={form} />
				</Form>
			</div>
		</>
	)
}

export default RentalAddPage
